import { useState } from 'react';

import { Add16 } from '@ingrid/iconography/react';
import { Button } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { useToast } from '~src/main/hooks/useToast';
import { FormValues } from '~src/pages/settings/address-book/components/address-book-form';
import { useAddressBookCreateMutation } from '~src/pages/settings/address-book/mutations';
import { createContactFromAddress } from '~src/utils/create-contact-from-address';

import { AddressType } from '../types';
import { AddressForm } from './address-form';
import { useAddresses } from './addresses-context';

interface Props {
  type: AddressType;
}

export function AddressCreate({ type }: Props) {
  const { contacts, setContacts, prefix } = useAddresses();
  const mutation = useAddressBookCreateMutation();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { toast } = useToast();

  async function onSubmit(data: FormValues, saveInAddressBook: boolean) {
    if (saveInAddressBook) {
      await toast.promise(mutation.mutateAsync(data), {
        success: { title: t('addressBook.create.success') },
        error: { title: t('addressBook.create.error') },
        loading: { title: t('addressBook.create.loading') },
      });
    } else {
      setContacts([createContactFromAddress(prefix, '', data.address, data.phone, data.email)!, ...contacts]);
    }

    setIsOpen(false);
  }

  return (
    <AddressForm
      onSubmit={onSubmit}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      type={type === 'customer_info.contact' ? 'contact' : 'address'}
      trigger={
        <Button variant="quaternary">
          <Add16 />
          <span>{t('shipments.address.createNew')}</span>
        </Button>
      }
    />
  );
}
